import { CharComp } from '@/components/CharComp'
import { getUserCenterPageRoute, PageRoutes, UserCenterRoutes } from '@/constants/PageRoutes'
import { ButtonType, useSpotOrdererBuy } from '@/hooks/use-spot-orderer-buy'
import classNames from 'classnames'
import { ElForm, ElFormItem } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useBaseInfoStore, useKlineStore, useUserInfoStore } from 'store'
import { CustomButton, HocElSlider, InputView, PrimaryPlusIcon } from 'ui-components'
import { DefineComponentProps } from 'utils'
import '../styles/orderer-buy-sell-layout.scss'

interface OrdererBuyProps {
  activeTab: string
  onClose?: () => void
}

export const OrdererBuy = defineComponent<OrdererBuyProps>({
  props: DefineComponentProps<OrdererBuyProps>(['activeTab', 'onClose']),
  setup(props) {
    const { t } = useI18n()
    const ordererBuy = useSpotOrdererBuy()
    const userStore = useUserInfoStore()
    const klineStore = useKlineStore()
    const router = useRouter()
    const baseInfoStore = useBaseInfoStore()
    const formatTooltip = (value: number) => {
      return `${value}%`
    }

    const gotoLogin = () => {
      router.push({
        path: PageRoutes.Login,
        query: {
          redirect: window.decodeURIComponent(router.currentRoute.value.path),
        },
      })
    }

    const gotoRegister = () => {
      router.push({
        path: PageRoutes.Register,
        query: {
          entry: 'spot_trade',
        },
      })
    }

    watch(
      () => props.activeTab,
      (val) => {
        if (val !== 'buy') {
          ordererBuy.onClear()
        }
      },
    )

    const onRecharge = () => {
      const data = baseInfoStore.getCoinStaticItemDataBySymbolId(klineStore.currentSymbolId!)
      router.push({
        path: getUserCenterPageRoute(UserCenterRoutes.Recharge),
        query: {
          itemId: data?.coinTo,
        },
      })
    }
    return () => (
      <div class="orderer-buy-sell-layout buy">
        {/* 按钮类型 */}
        <div class="button-type">
          {ordererBuy.buttonTypeList.map((item) => (
            <div
              class={classNames('button-type-item', {
                active: ordererBuy.buttonType.value === item.value,
              })}
              onClick={() => ordererBuy.handleButtonTypeChange(item.value)}
            >
              {t(item.label)}
            </div>
          ))}
        </div>
        <ElForm labelPosition="top">
          <ElFormItem label={t('价格')}>
            <InputView
              height={40}
              radius={6}
              v-model={ordererBuy.buyPrice.value}
              isFloatNumber
              disabled={ordererBuy.buttonType.value === ButtonType.Market}
              suffixIcon={() => 'USDT'}
              maxDecimalLength={klineStore.coinToPrecision}
            />
          </ElFormItem>
          <ElFormItem label={t('数量')}>
            <InputView
              height={40}
              radius={6}
              v-model={ordererBuy.buyAmount.value}
              placeholder={t('数量')}
              isFloatNumber
              onFocus={ordererBuy.onBuyAmountFocus}
              onBlur={ordererBuy.onBuyAmountBlur}
              onInput={ordererBuy.onBuyAmountInput}
              suffixIcon={() => ordererBuy.fromSpotSymbolName.value}
              maxDecimalLength={klineStore.coinFromPrecision}
            />
          </ElFormItem>
          <div class="px-8">
            <HocElSlider
              v-model={ordererBuy.slider.value}
              marks={ordererBuy.sliderMarks.value}
              formatTooltip={formatTooltip}
              onInput={(value) => ordererBuy.onSliderInput(value as number)}
            />
          </div>
          {/* 交易额 */}
          <div class="trade-amount">
            <span>{t('买入金额')}</span>
            <span class="trade-amount-value">
              <CharComp>{ordererBuy.tradeAmount.value.formatNumberWithCommas()} USDT</CharComp>
            </span>
          </div>
          {/* 可用 */}
          <div class="available">
            <span>{t('可用')}:</span>
            <span class="available-amount">
              <CharComp>
                {ordererBuy.availableAssets.value?.formatNumberWithCommas().decimalPadZero(klineStore.coinToPrecision) || '--'}
                &nbsp;
                {ordererBuy.toSpotSymbolName.value}
              </CharComp>
            </span>

            {userStore.isLogin && <PrimaryPlusIcon onClick={onRecharge} stroke="var(--colors-bg-icon-primary)" />}
          </div>
        </ElForm>

        {/* 登录显示登录注册 */}
        {!userStore.isLogin && (
          <div class="login-register">
            <CustomButton type={'primary'} onClick={gotoRegister}>
              {t('立即注册')}
            </CustomButton>
            <CustomButton type={'aux'} onClick={gotoLogin}>
              {t('登录')}
            </CustomButton>
          </div>
        )}
        {userStore.isLogin && (
          <CustomButton
            class="btn buy"
            type={'primary'}
            loading={ordererBuy.isLoading.value}
            primaryColor="var(--colors-up)"
            onClick={() =>
              ordererBuy.orderBuy(() => {
                ordererBuy.buyAmount.value = ''
                props.onClose?.()
              })
            }
          >
            <span>{t('买入')}</span>
            <span>{ordererBuy.fromSpotSymbolName.value}</span>
          </CustomButton>
        )}
      </div>
    )
  },
})
